import React from 'react'
import styled from 'styled-components'
import Panel from '../../components/Panel'
import UnitElementSection from './UnitElementSection'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
const ScrollingDiv = styled.div`overflow-y: auto;`

export default function UnitElementsBySections({
  sections,
  displayMapped,
  mappedElements,
  children,
}) {
  return (
    <Panel
      header="Unit Elements & Order"
      style={{ width: '100%', height: '100%' }}
      contentStyle={{
        height: 'calc(100% - 3em)',
        position: 'relative',
        boxSizing: 'border-box',
      }}>
      <Content>
        <div>
          {children}
        </div>
        <ScrollingDiv>
          {[]
            .concat(
              ...sections.map(({ subsections }, i) =>
                [].concat(
                  ...subsections.map(({ subsections }, j) =>
                    subsections.map((section, k) => [section, [i, j, k]]),
                  ),
                ),
              ),
            )
            .map(([section, sectionIndex], i) => {
              return (
                <UnitElementSection
                  key={i}
                  displayMapped={displayMapped}
                  mappedElements={mappedElements}
                  section={section}
                  sectionIndex={sectionIndex}
                />
              )
            })}
        </ScrollingDiv>
      </Content>
    </Panel>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/SummativePractical/UnitElementsBySections.js